// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

function initSwiper(){
  var cardSlider = new Swiper('.homepage_slider', {
    slidesPerView: 1.2,
    spaceBetween: 21,
    simulateTouch: true,
    
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: false,
    // },
    // If we need pagination
  //   pagination: {
  //     el: '.swiper-pagination',
  //     clickable: true,
  //   },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 21,
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 21,
      },
      1220: {
        slidesPerView: 4,
        spaceBetween: 15,
      }
    }
    // Navigation arrows
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // }
  });


  // function checkWindowWidth() {
  //   // Get the current window width
  //   var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  
  //   // Debugging: Log the current window width
  //   console.log('Window Width:', windowWidth);
  
  //   // Check if window width is above 1220
  //   if (windowWidth >= 1220) {
  //     // Debugging: Log that touch simulation is disabled
  //     console.log('Touch Simulation Disabled');
      
  //     // Disable touch simulation
  //     cardSlider.params.simulateTouch = false;
  //   } else {
  //     // Debugging: Log that touch simulation is enabled
  //     console.log('Touch Simulation Enabled');
      
  //     // Enable touch simulation
  //     cardSlider.params.simulateTouch = true;
  //   }
  
  //   // Update Swiper to apply the changes
  //   cardSlider.update();
  // }
  
  // // Initial check on page load
  // checkWindowWidth();
  
  // // Attach the function to the window resize event
  // window.addEventListener('resize', checkWindowWidth);


  
}

jQuery(document).ready(function() {
  setTimeout(function(){
      initSwiper();
  }, 100);

  


});